if (document.querySelector(".product-card__image-swatches") == null) return;
function initSwatches() {
  document.querySelectorAll(".product-card").forEach((productCard) => {
    const swatchesElement = productCard.querySelector("color-swatches");
    if (swatchesElement == null) return;
    const swatches = swatchesElement.querySelector(".product-card__image-swatches");
    if (swatches == null) return;
    const productImage = productCard.querySelector(".product-card__images .product-card__img");
    const cardLink = productCard.querySelector(".product-card__link");
    const cardTitle = productCard.querySelector(".product-card__title");
    const carouselContainer = productCard.querySelector(".carousel__container");
    const cardTab = productCard.querySelector(".product-card__tab");
    swatches.querySelectorAll(".image-swatches__item").forEach((swatch) => {
      const imageSrc = swatch.querySelector(".image-swatches__item-body")?.srcset;
      const swatchHref = swatch.href;
      swatch.addEventListener("mouseover", () => {
        productImage.srcset = imageSrc;
        // change all the hrefs on the product card
        if (cardLink) cardLink.href = swatchHref;
        if (cardTitle) cardTitle.href = swatchHref;
        if (carouselContainer) carouselContainer.href = swatchHref;
        if (cardTab) cardTab.href = swatchHref;
      });
    });
  });
}
function initSwatchesMouseOver() {
  const productCards = document.querySelectorAll(".product-card");
  for (const productCard of productCards) {
    productCard.addEventListener("mouseover", function () {
      initSwatches();
      const images = productCard.querySelectorAll(".image-swatches img");
      if (images)
        images.forEach((image) => {
          image.src = image.getAttribute("data-src");
          image.srcset = image.getAttribute("data-srcset");
        });
    });
  }
}
initSwatchesMouseOver();
window.addEventListener("pagination-loaded", function () {
  initSwatchesMouseOver();
});
window.addEventListener("filter-loaded", function () {
  initSwatchesMouseOver();
});

function debounce(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

const debouncedInitSwatches = debounce(initSwatchesMouseOver, 300);

function isRelevantMutation(mutations) {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.classList?.contains('product-card') || 
            node.querySelector?.('.product-card')
          ) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

const observer = new MutationObserver(function(mutations) {
  if (isRelevantMutation(mutations)) {
    debouncedInitSwatches();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});